module.exports = __webpack_public_path__ + "img/户部寨镇.a78df597.png";